import { Grid, Typography } from '@mui/material';
import { useStyles } from './styles/Report.styles';

interface ReportHeaderProps {
    title: string;
    rangeText?: string;
}

export const ReportHeader = ({ title, rangeText }: ReportHeaderProps) => {
    const classes = useStyles();

    return (
        <Grid container direction='row' className={classes.header}>
            <Grid container direction={'row'} className={classes.title}>
                <Grid item className={classes.reportTitle}>
                    <Typography className={classes.titleText}>
                        {title}
                    </Typography>
                </Grid>

                <Grid item className={classes.reportDate}>
                    <Typography className={classes.dateText}>
                        {rangeText ? rangeText : ''}
                    </Typography>
                </Grid>
            </Grid>
        </Grid>
    );
};
